import { HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs/operators';

export const toastInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    tap({
      next: (event: any) => {
        if (
          event?.status === 200 &&
          ['POST', 'PUT', 'DELETE'].includes(req.method)
        ) {
          //toast.success('Request successful');
        }
      },
      error: () => {
        //toast.error(message);
      }
    })
  );
};
